import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";

import { numberFormatting } from "../../../../shared/utility";
import { BUDGET_RANGE } from "../../../../system/global-enums";

const BudgetRange = () => {
  const {
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();

  const [rangeValue, setRangeValue] = useState(
    getValues("minBudget") >= BUDGET_RANGE.MIN &&
      getValues("maxBudget") >= BUDGET_RANGE.MIN
      ? [getValues("minBudget"), getValues("maxBudget")]
      : [BUDGET_RANGE.MIN, BUDGET_RANGE.MAX]
  );

  useEffect(() => {
    setValue("minBudget", rangeValue[0]);
    setValue("maxBudget", rangeValue[1]);

    // eslint-disable-next-line
  }, [rangeValue]);

  return (
    <div>
      <div className="question-heading">
        If your dream property had a budget slider, what would be the ballpark
        figure?
      </div>
      {errors.budgetRange && (
        <div className="error">{errors.budgetRange.message}</div>
      )}
      <div className="mt-5">
        <RangeSlider
          value={rangeValue}
          onInput={setRangeValue}
          min={BUDGET_RANGE.MIN}
          max={BUDGET_RANGE.MAX}
        />
      </div>
      <div className="mt-2 d-flex justify-content-between align-items-center range-values">
        <div>{numberFormatting(rangeValue[0])} USD</div>
        {/* If the max value is reached, show '1 million +' */}
        <div>
          {rangeValue[1] === BUDGET_RANGE.MAX
            ? "1M+ USD"
            : `${numberFormatting(rangeValue[1])} USD`}
        </div>
      </div>
    </div>
  );
};

export default BudgetRange;
